<template>
    <div class="animated fade-in">
        <h1 class="display-4 font-weight-lighter">Customers</h1>
        <div class="my-5"></div>
        <CRow align-horizontal="center">
            <CCol col="8">
                <CRenderFunction flat :content-to-render="nav"/>
            </CCol>
        </CRow>
        <div class="my-5"></div>
    </div>
</template>

<script>
  import Vue from 'vue'
  import nav from './_nav'
  import DashboardTiles from '@/components/DashboardTiles'
  Vue.component('DashboardTiles', DashboardTiles);
  import DashboardTile from '@/components/DashboardTile'
  Vue.component('DashboardTile', DashboardTile);

  export default {
    name: "CustomerDashboard",
    data() {
      return {nav}
    }
  };
</script>
